import { NormalizedListing } from 'ha/modules/Algolia/Types';
import transformImageUrlToBosch from 'ha/utils/urls/transformImageUrlToBosch';

import { ListingAttributes } from '../types';

export function normalizeAlgoliaListing(
  listing: NormalizedListing,
): ListingAttributes {
  const transformImageUrl = (url: string) =>
    transformImageUrlToBosch(url, { size: '450x300', transformation: 'crop' });

  return {
    id: listing.id,
    price: listing.price,
    currency: listing.currency,
    street: listing.street,
    city: listing.city,
    isNew: listing.isNew,
    previewImage:
      listing.previewImage && transformImageUrl(listing.previewImage),
    photos: listing.photos?.map(transformImageUrl),
    minimalRentalPeriod: listing.minimalRentalPeriod,
    listingPath: listing.listingPath,
    kind: listing.kind,
    type: listing.type,
    exclusions: listing.exclusions,
    waterCostIncluded: listing.facility_water_cost_included,
    gasCostIncluded: listing.facility_gas_cost_included,
    electricityIncluded: listing.facility_electricity_included,
    internetIncluded: listing.facility_internet_included,
    bedroomFurnished: listing.facility_bedroom_furnished,
    bedroomCount: listing.facility_bedroom_count,
    totalSize: listing.facility_total_size,
    bedroomSize: listing.facility_bedroom_size,
  };
}
